export const ehrNoteState = {
  ehrNoteList: [],
  ehrNoteExpanded: false,
  currentEhrNote: {},
  ehrNoteSubmitting: false,
  ehrNoteFocused: false,
  canEditEHRNote: false,
};
